import { render } from "./OapVideoPopin.vue?vue&type=template&id=1d756bb2"
import script from "./OapVideoPopin.vue?vue&type=script&lang=js"
export * from "./OapVideoPopin.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__